module.exports = __webpack_public_path__ + "assets/img/mobile-phone.ac685afa.png";